import { useState, useEffect } from 'react';
import DustParticles from './DustParticles';
import HeatWaves from './HeatWaves';

const SunsetAesthetics = () => {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    setIsDarkMode(document.documentElement.classList.contains('dark'));
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Floating dust particles */}
      <DustParticles isDarkMode={isDarkMode} />

      {/* Layer 2: Heat shimmer waves */}
      <HeatWaves isDarkMode={isDarkMode} />
    </div>
  );
};

export default SunsetAesthetics;
